"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _wizard = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/wizard.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _wizard.default);
/** WizardContainer is a minimal wrapper for the whole wizard component. Should
 * be used as a container for `Wizard.Navigation`, `Wizard.Content` and
 * `Wizard.Footer` components when building the wizard manually, without the
 * build-in logic (but it allows any content).
 *
 * @returns {Node} WizardContainer component
 */

function WizardContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "cssNamespace"]);
  var wizardClasses = classnames("".concat(cssNamespace, "-wizard"), className);
  return /*#__PURE__*/_react.default.createElement("section", (0, _extends2.default)({
    className: wizardClasses
  }, props), children);
}

process.env.NODE_ENV !== "production" ? WizardContainer.propTypes = {
  /** Wizard contents to render (should be `Wizard.Navigation`,
   * `Wizard.Content` and `Wizard.Footer` respectively) */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(WizardContainer);

exports.default = _default;